<template>
  <section id="compare" class="c__section section__compare section__04">
    <div class="c__container">
      <div class="c__headblock">
        <h2 class="c__leadcopy navy c__no__anm">商品を比較する</h2>
        <p class="navy c__bodycopy c__no__anm">
          左右で商品を見比べたり、<br />
          カラーを見比べたりしながら<br />
          自分好みのBAKUNEを見つけましょう。
        </p>
      </div>
      <div class="compare__wrap">
        <div class="compare__container">
          <FeaturesHowtochooseRecoverywearSleepitemPartsCompareProduct
            :products="props.products"
            :is-compare-base="true"
            :selected="baseSelected"
            @open-fav-modal="onOpenFavModal"
          />
          <FeaturesHowtochooseRecoverywearSleepitemPartsCompareProduct
            :products="props.products"
            :is-compare-base="false"
            :selected="compareSelected"
            @change="onChange"
            @open-fav-modal="onOpenFavModal"
          />
        </div>
      </div>
    </div>
    <!-- お気に入りモーダル -->
    <MoleculesConsumerModal v-model="isOpenFavModal">
      <ProductSelectFav
        :product="favModalProduct"
        :favorite-list="favoriteListRef"
        :is-processing="isProcessing"
        @on-favorite="onFavoriteByProductList"
        @lift="isOpenFavModal = false"
      />
    </MoleculesConsumerModal>
  </section>
</template>

<script setup lang="ts">
import { BakuneTopProduct, SearchConditionSelected } from "~/utils/functions/howtochoose_recoverywear_sleepitem"
import { useFavorite } from "~/composables/useFavorite"
import type { PagePartsProductType } from "~/types/product"

const { openFavModal, isOpenFavModal, favModalProduct, favoriteListRef, isProcessing, onFavoriteByProductList } =
  useFavorite()

const props = defineProps<{
  products: BakuneTopProduct[]
  selected: SearchConditionSelected
}>()

const baseSelected = ref<SearchConditionSelected>({
  sex: "unisex",
  silhouette: "",
  fabric: "",
  sleevesAndPants: "",
  detail: "",
})

const compareSelected = ref<SearchConditionSelected>({
  sex: "",
  silhouette: "",
  fabric: "",
  sleevesAndPants: "",
  detail: "",
})

const sessionKey = "howtochoose_recoverywear_sleepitem_compare"

const onChange = (searchConditionSelected: SearchConditionSelected) => {
  compareSelected.value = searchConditionSelected
  // 選択した条件をセッションストレージに保存
  sessionStorage.setItem(sessionKey, JSON.stringify(compareSelected.value))
}

const onOpenFavModal = (event: Event, product: PagePartsProductType) => {
  openFavModal(event, product)
}

onMounted(() => {
  // 選択した条件をセッションストレージから取得
  const savedCompareSelected = sessionStorage.getItem(sessionKey)
  if (savedCompareSelected) {
    compareSelected.value = JSON.parse(savedCompareSelected) as SearchConditionSelected
  }
})

watch(
  () => props.selected,
  (newSelected) => {
    baseSelected.value = newSelected
  },
)
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
